/**
 * useGateCampaign Hook
 *
 * Fetches and manages Gate wallet campaign status.
 * Returns campaign details including:
 * - Whether campaign is active
 * - User's bonus points earned
 * - Remaining bonus available
 * - Campaign dates
 * - Whether user is using Gate wallet
 */

import { useQuery } from '@tanstack/react-query';

import { getGateCampaignStatus } from '@/api/auth';

export function useGateCampaign() {
  const query = useQuery({
    queryKey: ['gateCampaign'],
    queryFn: async () => {
      const response = await getGateCampaignStatus();
      if (response.code !== 0) {
        throw new Error(response.message || 'Failed to fetch campaign status');
      }
      return response.data;
    },
    staleTime: 30 * 1000, // Cache for 30 seconds
    refetchInterval: 60 * 1000, // Refetch every 60 seconds to keep countdown updated
  });

  return {
    campaignData: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
